import Loadable from '../../components/loadable';

const WaiverSignedWaiversList = Loadable({
  loader: () => import('../../pages/waivers/waiver_signed_waivers_list/waiver_signed_waivers_list'),
  type: 'block',
});

angular.module('gym').value('WaiverSignedWaiversList', WaiverSignedWaiversList);

const WaiverSignedWaiversListFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/waivers/waiver_signed_waivers_list/waiver_signed_waivers_list_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('WaiverSignedWaiversListFiltersModal', WaiverSignedWaiversListFiltersModal);
